import { setToken } from 'lib/common'
import { globalConst as native, mutationNames } from 'lib/const'
import { isEmptyObject, margeMutations, hexToUTF8Str } from 'lib/utils'
import { applyClientMiddleware } from 'src/main'
import api from 'api/api'
import PackageFile from 'lib/packageFile'
import { createModule } from 'plugins/vuex-request/VuexModule'

const state = {}

const getters = {}
const actions = {
  [native.resListAll] ({state}, refs) {
    return applyClientMiddleware(api.resListAll, refs)
  },
  [native.resTypeList] ({state}, refs) {
    return applyClientMiddleware(api.resTypeList, refs)
  },
  [native.resList] ({state}, refs) {
    return applyClientMiddleware(api.resList, refs)
  },
  [native.resDetail] ({state}, refs) {
    return applyClientMiddleware(api.resDetail, refs)
  },
  [native.resSearch] ({state}, refs) {
    return applyClientMiddleware(api.resSearch, refs)
  },
  [native.installPack] ({state}, refs) {
    console.log('log==>', refs)
    return applyClientMiddleware(api.installPack, refs)
  }
}
let mutations = {}
mutations = Object.assign(margeMutations(actions), mutations)
export default createModule(state, getters, actions, mutations, false)
